<template>
    <div class="lesson-manual-edit">
        <div
            class="apprentice-simple-card"
            v-if="lessons.length === 0">
            <div class="not-found with-header empty-lessons-manual">
                <div
                    class="btn-add-circle icon"
                    v-b-tooltip.hover
                    :title="$t('lesson.add_lesson')"
                    @click="showCreateLessonModal"></div>
                <div class="alert-notice">{{ $t('lesson.no_lessons_found') }}</div>
            </div>
        </div>

        <div
            class="row"
            v-else>
            <div class="col-12 col-xl-4 col-xxl-3">
                <design-2021-group-lesson-manual-nav-component
                    :lessons-in="lessons"
                    :parent-in="lessonModuleIn"
                    :selected-lesson-in="selectedLesson"
                    :parent-type="'lesson_module'"
                    :editable="true"
                    @lesson-updated="updateLesson"
                    @lesson-removed="removeLesson"
                    @change-lesson="updateSelectedLesson"
                    @show-create-lesson-modal="showCreateLessonModal">
                </design-2021-group-lesson-manual-nav-component>
            </div>

            <div class="col-12 col-xl-8 col-xxl-9">
                <design-2021-lesson-manual-lesson-overview-component
                    v-if="lessonModuleIn.lessons.length > 0"
                    :editable="true"
                    @lesson-updated="updateLesson"
                    :lesson-in="selectedLesson">
                </design-2021-lesson-manual-lesson-overview-component>
            </div>
        </div>

        <design-2021-create-lesson-modal-component
            :parent-in="lessonModuleIn"
            parent-type="lesson_module"
            ref="create-lesson-modal"
            @lesson-created="storeLesson">
        </design-2021-create-lesson-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-lessons-index-component',
    props: {
        lessonModuleIn: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            lessons: this.lessonModuleIn.lessons,
            selectedLesson: this.lessonModuleIn.lessons.length ? this.lessonModuleIn.lessons[0] : {},
        };
    },

    methods: {
        updateSelectedLesson(lesson) {
            this.selectedLesson = this.lessons.find((lesson0) => lesson0.id === lesson.id);
        },

        updateLesson(lessonNew) {
            this.lessons = this.lessons.map((lessonOld) => {
                if (lessonOld.id === lessonNew.id) {
                    return lessonNew;
                }
                return lessonOld;
            });
            this.updateSelectedLesson(lessonNew);
            this.alert.success();
        },

        showCreateLessonModal() {
            this.$refs['create-lesson-modal'].show();
        },

        storeLesson(lesson) {
            this.lessons.push(lesson);
            this.selectedLesson = lesson;
            this.alert.success();
        },

        removeLesson(lessonId) {
            this.lessons = this.lessons.filter((lesson) => lesson.id !== lessonId);
            if (this.selectedLesson.id === lessonId) {
                this.selectedLesson = this.lessons.length === 0 ? {} : this.lessons[this.lessons.length - 1];
            }
        },
    },
};
</script>

<style scoped lang="scss">
.empty-lessons-manual {
    margin: map-get($grid-gutter-spacing, 'forty-two') 0;
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    ::v-deep {
        .lesson-overview {
            width: 96%;
            margin-left: auto;
        }
    }
}
</style>
